import { render } from "./MainPages.vue?vue&type=template&id=2a12c6fd"
import script from "./MainPages.vue?vue&type=script&lang=js"
export * from "./MainPages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__